// src/welcome.ts
// Every member's first letter: a short hello from the PenPal Board team,
// like a friend showing a new friend around. It isn't stored in the
// database; the inbox writes it on the fly. Whether you've opened it or
// thrown it away is saved on your profile as `welcome` ("read" or
// "trashed"), and in this browser too.

export const WELCOME_ID = "welcome";
export const WELCOME_FROM = "2slgbtqiapenpal";
export const TEAM_EMAIL = "2slgbtqiapenpal@gmail.com";
// where the welcome letter's "Introduce yourself" button goes
export const INTRODUCE_LINK = "/community/introductions?write=1";

// Names only the team can have (set by hand in the Firebase console), so
// nobody can pretend to be us. Keep in step with firestore.rules.
export const RESERVED_USERNAMES = [
  "2slgbtqiapenpal",
  "2slgbtqiapenpals",
  "penpalboard",
  "penpal_board",
  "admin",
  "moderator",
  "mod",
  "postoffice",
  "the_post_office",
];

export const isReservedUsername = (name: string) => RESERVED_USERNAMES.includes(name.toLowerCase());

// No emoji: only what a 90s web page could type (plain text, :) <3 ~*~,
// and the old HTML entities like &hearts; and &raquo;).
export const WELCOME_SUBJECT = "~*~ hi, you made it! ~*~";

export const welcomeBody = (username?: string) => `hi ${username ? "@" + username : "friend"}!

we're so glad you're here. take a moment to breathe, drink some water, and rest a bit, friend :)

a quick tour of the place:

» the PenPal Board is where folks pin up letters looking for pen pals. read a few, and pin your own whenever you're ready (anonymous is okay too!)
» the Community Rooms are for hanging out, no pen pal needed
» your little plant lives on My Profile. water it when you visit. it never wilts, promise
» come say hi in the Introductions room. we'd love to meet you

make sure to take your time building your profile and creating your avatar. there's no rush, it'll all be here when you're ready.

everyone here goes at their own pace, so take yours. and if anything ever feels off, Safety & Rules has your back.

you can always reach us by email at ${TEAM_EMAIL}. we really appreciate any feedback too <3

happy writing ♥

-Slug & Worm, the ${WELCOME_FROM} team`;
